import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { Button } from '@/components/ui/button.tsx';
import { MoreHorizontalIcon } from 'lucide-react';
import { getAdminProductUrl } from '@/app/products/api/endpoints.ts';
import { TListProduct, TUser, userCanEditProducts } from '@/types/models.ts';
import { useState } from 'react';
import { EditProductDialog } from '@/app/products/list/admin/edit-product-dialog.tsx';
import { useAdminProductReindexMutation } from '@/app/products/api/queries.ts';
import { AppTooltip } from '@/components/app/app-tooltip.tsx';
import { setUiUpdated } from '@/stores/ui.store.ts';

export function AdminDropdown({ item, user, currIndex }: { item: TListProduct; user: TUser; currIndex: number }) {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const onAdminViewSelect = () => {
    const color = item.colors[currIndex] ? item.colors[currIndex] : null;
    window.open(getAdminProductUrl(item.id, color?.id), '_blank');
  };
  const reindexProduct = useAdminProductReindexMutation();
  const onReindexSelect = () => {
    reindexProduct.mutate(item.id);
    setUiUpdated();
  };
  return (
    <>
      <DropdownMenu modal={false}>
        <AppTooltip tooltip="Admin Options">
          <DropdownMenuTrigger asChild>
            <Button className="admin-btn" variant="outline" aria-label="Open menu" size="icon-sm">
              <MoreHorizontalIcon />
            </Button>
          </DropdownMenuTrigger>
        </AppTooltip>
        <DropdownMenuContent align="start">
          {userCanEditProducts(user) && (
            <DropdownMenuItem onClick={() => setShowEditDialog(true)}>Edit Product</DropdownMenuItem>
          )}
          <DropdownMenuItem onSelect={onAdminViewSelect}>Admin View</DropdownMenuItem>
          <DropdownMenuItem onSelect={onReindexSelect}>Reindex</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {showEditDialog && (
        <EditProductDialog item={item} currIndex={currIndex} onClose={() => setShowEditDialog(false)} />
      )}
    </>
  );
}
